<template>
  <div class="v2-theme">
    <v2-modal
      :show="true"
      size="md"
      @close="clearContext"
    >
      <template #header>
        <span />
      </template>
      <confetti-animation>
        <div class="v2-order-success">
          <div class="v2-order-success__icon">
            <order-box-icon />
          </div>
          <template v-if="isMultiple">
            <div class="v2-order-success__text">
              <div>Congratulations!</div>
              <div>{{ orderIds.length }} orders are successfully placed!</div>
            </div>
            <div class="v2-order-success__order-list v2-scroll-bar">
              <div
                v-for="orderIdItem in orderIds"
                :key="orderIdItem.orderId"
                class="v2-order-success__order-item"
              >
                <div class="v2-order-success__order-item-info">
                  <div class="v2-order-success__order-item-text">
                    Order {{ orderIdItem.orderSeqId }}
                  </div>
                  <div class="v2-order-success__skeleton" />
                  <div class="v2-order-success__skeleton v2-order-success__skeleton--short" />
                </div>
                <div class="v2-order-success__order-item-action">
                  <v2-button
                    variant="secondary"
                    size="sm"
                    @click="onClickGoToOrder(orderIdItem.orderId)"
                  >
                    Go to Order
                  </v2-button>
                </div>
              </div>
            </div>
            <div class="v2-order-success__actions">
              <v2-button
                variant="outline"
                size="md"
                @click="onClickGoToCheckout"
              >
                Place another order
              </v2-button>
            </div>
          </template>
          <template v-else>
            <div class="v2-order-success__text">
              <div>Congratulations!</div>
              <div>Order {{ orderIds[0].orderSeqId }} is successfully placed!</div>
            </div>
            <div class="v2-order-success__actions">
              <v2-button
                variant="outline"
                size="md"
                @click="onClickGoToCheckout"
              >
                Place another order
              </v2-button>
              <v2-button
                variant="primary"
                size="md"
                @click="onClickGoToOrders"
              >
                Go to Orders
              </v2-button>
            </div>
          </template>
        </div>
      </confetti-animation>
    </v2-modal>
  </div>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'
import OrderBoxIcon from '@/assets/images/svg/OrderBoxIcon.vue'
import ConfettiAnimation from '@/views/components/confetti-animation/ConfettiAnimation.vue'

export default {
  name: 'V2OrderSuccessModal',
  components: {
    V2Modal,
    V2Button,
    OrderBoxIcon,
    ConfettiAnimation,
  },
  props: {
    orderIds: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    isMultiple() {
      return this.orderIds.length > 1
    },
  },
  methods: {
    clearContext() {
      this.$root.$orderSuccessPopupContext.value = null
    },
    onClickGoToOrders() {
      this.clearContext()
      this.$router.push('/v2/orders')
    },
    onClickGoToOrder(orderId) {
      this.clearContext()
      this.$router.push(`/v2/order/${orderId}`)
    },
    onClickGoToCheckout() {
      this.clearContext()
      this.$router.push('/v2/checkout')
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-order-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem 0;

  &__icon {
    margin-bottom: 1.5rem;
  }

  &__text {
    font-family: var(--v2-font-display);
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--v2-foreground);
    line-height: 1.4;
    margin-bottom: 1.5rem;
  }

  &__order-list {
    width: 100%;
    max-height: 350px;
    overflow-y: auto;
    margin-bottom: 1rem;
  }

  &__order-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--v2-muted);
    border-left: 4px solid var(--v2-primary);
    border-radius: 0 var(--v2-radius-sm) var(--v2-radius-sm) 0;
    padding: 0.75rem 1rem;
    margin-bottom: 0.5rem;
  }

  &__order-item-info {
    text-align: left;
    flex: 1;
  }

  &__order-item-text {
    font-weight: 600;
    font-size: 1rem;
    color: var(--v2-foreground);
    line-height: 1.5;
  }

  &__skeleton {
    height: 0.75rem;
    width: 75%;
    background: var(--v2-border);
    border-radius: var(--v2-radius-sm);
    margin-top: 0.375rem;

    &--short {
      width: 50%;
    }
  }

  &__order-item-action {
    flex-shrink: 0;
    margin-left: 1rem;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
}
</style>
